import { Form, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { getData } from "../../repository/api";

const { Option } = Select;

const CategoryFormModal = ({ visible, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await getData("/GetAccount/");
      const mapped = response.map((item) => ({
        name: item.AccountName,
        value: item.id,
      }));
      setAccounts(mapped);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        CategoryName: initialValues.CategoryName,
        PartentCategory: initialValues.PartentCategory,
        IncomeAccount_id: initialValues.IncomeAccount?.id,
        ExpenseAccount_id: initialValues.ExpenseAccount?.id,
      });
    }
  }, [initialValues, form]);

  const handleFinish = (values) => {
    onSubmit(values);
    form.resetFields();
  };

  return (
    <Modal
      title={initialValues ? "Edit Category" : "Add Category"}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      okText={initialValues ? "Update" : "Create"}
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          name="CategoryName"
          label="Category Name"
          rules={[{ required: true, message: "Please enter category name" }]}
        >
          <Input placeholder="Enter category name" />
        </Form.Item>

        <Form.Item
          name="PartentCategory"
          label="Parent Category"
          rules={[
            { required: true, message: "Please enter parent category name" },
          ]}
        >
          <Input placeholder="Enter parent category" />
        </Form.Item>

        <Form.Item
          label="Income Account"
          name="IncomeAccount_id"
          rules={[
            {
              required: true,
              message: "Please select income account",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select income account"
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          >
            {accounts.map((acc) => (
              <Select.Option key={acc.value} value={acc.value} label={acc.name}>
                {acc.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Expense Account"
          name="ExpenseAccount_id"
          rules={[
            {
              required: true,
              message: "Please select expense account",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select expense account"
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          >
            {accounts.map((acc) => (
              <Select.Option key={acc.value} value={acc.value} label={acc.name}>
                {acc.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryFormModal;
